import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { BLOG_APP_ID } from '../../constants/applications';
import { replace } from '../../services/router-utils';
import { buttonClicked } from '../../actions/button-clicked';
import { logoutMember } from '../../actions/logout-member';
import ActionButton from '../../components/action-button';
import { getUserRoleByApp } from '../../services/user-role';
import { getApplicationConfig } from '../../selectors/communities-context-selectors';
import withTranslate from '../../hoc/with-translate';
import withAuth from '../../hoc/with-auth';
import withEnvironment from '../../hoc/with-environment';
import { isMemberPartInstalled } from '../../selectors/is-member-part-installed';
import { isMemberAreaActive } from '../../selectors/member-area-selectors';

export class PrivateProfileActions extends Component {
  handleGoToProfile = () => {
    const { buttonClicked, navigation: { navigateToProfile }, user } = this.props;
    buttonClicked({ action: 'profile' });
    navigateToProfile(user);
  };

  handleLogout = () => {
    const { buttonClicked, navigateToRoot, logoutMember } = this.props;
    navigateToRoot();
    buttonClicked({ action: 'logout' });
    logoutMember();
  };

  handleGoToSettings = () => {
    const { buttonClicked, navigation: { navigateToProfileSettings }, user } = this.props;
    buttonClicked({ action: 'settings' });
    navigateToProfileSettings(user);
  };

  handleGoToCreatePost = () => {
    const { buttonClicked, navigation: { navigateToCreatePost } } = this.props;
    buttonClicked({ action: 'create_post' });
    navigateToCreatePost();
  };

  handleGoToMyDrafts = () => {
    const { buttonClicked, navigation: { navigateToMyDrafts }, user } = this.props;
    buttonClicked({ action: 'my_drafts' });
    navigateToMyDrafts(user);
  };

  render() {
    const { blogConfig: { isInstalled }, isMemberPartInstalled, currentUser, t } = this.props;
    const canWrite = ['owner', 'writer'].indexOf(getUserRoleByApp(currentUser, BLOG_APP_ID)) > -1;
    return (
      <div>
        <ActionButton data-hook="private-profile-actions__profile" onClick={this.handleGoToProfile}>
          {t('breadcrumbs.profile')}
        </ActionButton>
        {isInstalled &&
          canWrite && (
            <ActionButton data-hook="private-profile-actions__create-post" onClick={this.handleGoToCreatePost}>
              {t('private-profile-actions.create-post')}
            </ActionButton>
          )}
        {isInstalled && isMemberPartInstalled &&
          canWrite && (
            <ActionButton data-hook="private-profile-actions__drafts" onClick={this.handleGoToMyDrafts}>
              {t('private-profile-actions.my-drafts')}
            </ActionButton>
          )}
        <ActionButton data-hook="private-profile-actions__settings" onClick={this.handleGoToSettings}>
          {t('private-profile-actions.settings')}
        </ActionButton>
        <ActionButton data-hook="private-profile-actions__logout" onClick={this.handleLogout}>
          {t('private-profile-actions.logout')}
        </ActionButton>
      </div>
    );
  }
}

PrivateProfileActions.propTypes = {
  blogConfig: PropTypes.object,
  buttonClicked: PropTypes.func,
  currentUser: PropTypes.object,
  logoutMember: PropTypes.func,
  navigation: PropTypes.object,
  navigateToRoot: PropTypes.func,
  t: PropTypes.func,
  user: PropTypes.object,
  isMemberPartInstalled: PropTypes.bool,
  isMemberAreaActive: PropTypes.bool,
};

const mapStateToProps = state => ({
  blogConfig: getApplicationConfig(state, BLOG_APP_ID),
  isMemberPartInstalled: isMemberPartInstalled(state),
  isMemberAreaActive: isMemberAreaActive(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    buttonClicked: data => buttonClicked({ name: 'action_click', type: 'profile', ...data }),
    logoutMember,
    navigateToRoot: () => replace('/'),
  }, dispatch);

// prettier-ignore
export default flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withAuth,
  withEnvironment({ navigation: 'navigation' }),
  withTranslate
)(PrivateProfileActions);



// WEBPACK FOOTER //
// ./app/containers/private-profile-actions/private-profile-actions.js